import {createContext, useContext, ReactNode} from 'react'
import {OrderIntakeSite} from '../rmc/orderIntake/types/OrderIntakeSite.types'

interface JobSiteCreationProcessContextValue {
  onCreateNewOrder: (site: OrderIntakeSite) => void
}

const JobSiteCreationProcessContext = createContext<JobSiteCreationProcessContextValue | null>(null)

export const useJobSiteCreationProcessContext = (): JobSiteCreationProcessContextValue => {
  const context = useContext(JobSiteCreationProcessContext)
  if (!context) {
    throw new Error(
      'useJobSiteCreationProcessContext must be used within a JobSiteCreationProcessContextProvider'
    )
  }
  return context
}

interface JobSiteCreationProcessContextProviderProps {
  children: ReactNode
  onCreateNewOrder: (site: OrderIntakeSite) => void
}

export const JobSiteCreationProcessContextProvider = ({
  children,
  onCreateNewOrder
}: JobSiteCreationProcessContextProviderProps) => {
  const contextValue: JobSiteCreationProcessContextValue = {
    onCreateNewOrder
  }

  return (
    <JobSiteCreationProcessContext.Provider value={contextValue}>
      {children}
    </JobSiteCreationProcessContext.Provider>
  )
}
